import { leyanbotClient } from 'services/api';

interface GetTFERPURLParams {
  externalStoreId: string;
  region: string;
  tunnelType: string;
  orderId: string;
}

/**
 * 获取 TFERP 页面地址
 * error code
 * 20001: TFERP_NO_SECRET 没有密钥
 * 20002: TFERP_WRONG_SECRET 密钥错误
 * 20003: TFERP_WRONG_BASEURL 域名错误
 * 20004: TFERP_WRONG_SECRET_OR_BASEURL
 */
export const getTFERPURL = (params: GetTFERPURLParams) => {
  return leyanbotClient.get<{ url: string }>('/openchatppdoc/api/tferp/getUrl', {
    params,
  });
};

// 保存 TFERP 参数
export const saveTFERPParams = (list: Array<{ key: string; value: string }>) => {
  return leyanbotClient.post<{ kvs: Array<{ key: string; value: string }> }>(
    '/openchatpp/api/tferp/saveParam',
    {
      kvs: list,
    },
  );
};

// 获取 TFERP 参数
export const getTFERPParams = () => {
  return leyanbotClient.get<{ kvs: Array<{ key: string; value: string }> }>(
    '/openchatpp/api/tferp/getParam',
  );
};

// 保存 TFERP 密钥
export const saveTFERPSecret = (secret: string) => {
  return leyanbotClient.post<{ secret: string }>('/openchatppdoc/api/tferp/saveSecret', { secret });
};

// 保存 TFERP 密钥
export const getTFERPSecret = () => {
  return leyanbotClient.get<{ secret: string }>('/openchatppdoc/api/tferp/getSecret');
};

// 获取 TFERP 版本
export const getTFERPVersion = () => {
  return leyanbotClient.get<{ version: 'V2' | 'V3' }>('/openchatppdoc/api/tferp/getVersion');
};
